module.exports = __webpack_public_path__ + "static/media/super_manage.41b2a207.png";